import React from 'react';
import { mergeNamesToString } from '@common/utils/merged-names-text';
import './moderator-row.scss';
import { useLocation, useParams } from 'react-router';
import LinkWrapper from '@common/components/linkWrapper';
import Profile from '@common/components/profile';

export default function ModeratorRow({ item, children }) {
  const { networkId, id } = useParams();
  const { pathname } = useLocation();
  const baseUrl = pathname.includes('/networks/') || networkId ? `/networks/${networkId || id}` : '/admin';
  return (
    <div className="ChannelForm__ModeratorRow">
      <LinkWrapper url={`${baseUrl}/users/${item.user_id ?? item.id}/about`} target="_blank" className="tw-flex-grow tw-text-inherit hover:tw-text-inherit hover:tw-underline">
        <Profile size={30} enablePopover user={{ id: item?.user_id || item?.id, full_name: item?.full_name, profile_img: item?.profile_img }} />
      </LinkWrapper>
      {children}
      <span>{mergeNamesToString(item?.roles?.map(({ name }) => name) || [])}</span>
    </div>
  );
}
